var map = {
	"./all-offers/all-offers.module": [
		"./src/app/all-offers/all-offers.module.ts",
		"all-offers-all-offers-module"
	],
	"./appointment-bookings/appointment-bookings.module": [
		"./src/app/appointment-bookings/appointment-bookings.module.ts",
		"appointment-bookings-appointment-bookings-module"
	],
	"./appointment-schedules/appointment-schedules.module": [
		"./src/app/appointment-schedules/appointment-schedules.module.ts"
	],
	"./auto-confirm-payment/auto-confirm-payment.module": [
		"./src/app/auto-confirm-payment/auto-confirm-payment.module.ts"
	],
	"./booking-link/booking-link.module": [
		"./src/app/booking-link/booking-link.module.ts",
		"common",
		"booking-link-booking-link-module"
	],
	"./booking/booking-schedule/booking-schedule.module": [
		"./src/app/booking/booking-schedule/booking-schedule.module.ts"
	],
	"./booking/user-booking-details/user-booking-details.module": [
		"./src/app/booking/user-booking-details/user-booking-details.module.ts"
	],
	"./booking/user-booking/user-booking.module": [
		"./src/app/booking/user-booking/user-booking.module.ts",
		"booking-user-booking-user-booking-module"
	],
	"./buynow-pricelist-modal/buynow-pricelist-modal.module": [
		"./src/app/buynow-pricelist-modal/buynow-pricelist-modal.module.ts",
		"default~buynow-pricelist-modal-buynow-pricelist-modal-module~product-details-product-details-module",
		"buynow-pricelist-modal-buynow-pricelist-modal-module"
	],
	"./chat-bot/chat-bot.module": [
		"./src/app/chat-bot/chat-bot.module.ts"
	],
	"./image-modal/image-modal.module": [
		"./src/app/image-modal/image-modal.module.ts"
	],
	"./new-address/map/map.module": [
		"./src/app/new-address/map/map.module.ts"
	],
	"./new-address/new-address.module": [
		"./src/app/new-address/new-address.module.ts"
	],
	"./offer-details/offer-details.module": [
		"./src/app/offer-details/offer-details.module.ts"
	],
	"./order-payment/order-payment.module": [
		"./src/app/order-payment/order-payment.module.ts"
	],
	"./order-summary/order-summary.module": [
		"./src/app/order-summary/order-summary.module.ts",
		"order-summary-order-summary-module"
	],
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/cancelation-policy/cancelation-policy.module": [
		"./src/app/pages/cancelation-policy/cancelation-policy.module.ts",
		"pages-cancelation-policy-cancelation-policy-module"
	],
	"./pages/cancelled-reason/cancelled-reason.module": [
		"./src/app/pages/cancelled-reason/cancelled-reason.module.ts"
	],
	"./pages/contact/contact.module": [
		"./src/app/pages/contact/contact.module.ts",
		"pages-contact-contact-module"
	],
	"./pages/coupons-list/coupons-list.module": [
		"./src/app/pages/coupons-list/coupons-list.module.ts"
	],
	"./pages/custom-page/custom-page.module": [
		"./src/app/pages/custom-page/custom-page.module.ts",
		"pages-custom-page-custom-page-module"
	],
	"./pages/custom-payment-option/custom-payment-option.module": [
		"./src/app/pages/custom-payment-option/custom-payment-option.module.ts"
	],
	"./pages/faq/faq.module": [
		"./src/app/pages/faq/faq.module.ts",
		"pages-faq-faq-module"
	],
	"./pages/form-modal/form-modal.module": [
		"./src/app/pages/form-modal/form-modal.module.ts"
	],
	"./pages/hdfc-redirect/hdfc-redirect/hdfc-redirect.module": [
		"./src/app/pages/hdfc-redirect/hdfc-redirect/hdfc-redirect.module.ts",
		"pages-hdfc-redirect-hdfc-redirect-hdfc-redirect-module"
	],
	"./pages/homepage/homepage.module": [
		"./src/app/pages/homepage/homepage.module.ts",
		"common",
		"pages-homepage-homepage-module"
	],
	"./pages/membership/membership.module": [
		"./src/app/pages/membership/membership.module.ts",
		"pages-membership-membership-module"
	],
	"./pages/my-account/my-account.module": [
		"./src/app/pages/my-account/my-account.module.ts",
		"pages-my-account-my-account-module"
	],
	"./pages/not-found/not-found.module": [
		"./src/app/pages/not-found/not-found.module.ts",
		"pages-not-found-not-found-module"
	],
	"./pages/order-failure/order-failure.module": [
		"./src/app/pages/order-failure/order-failure.module.ts",
		"pages-order-failure-order-failure-module"
	],
	"./pages/order-successful/order-successful.module": [
		"./src/app/pages/order-successful/order-successful.module.ts",
		"pages-order-successful-order-successful-module"
	],
	"./pages/payment-module/payment-module.module": [
		"./src/app/pages/payment-module/payment-module.module.ts"
	],
	"./pages/payment-ui/paypal/paypal.module": [
		"./src/app/pages/payment-ui/paypal/paypal.module.ts"
	],
	"./pages/payment-ui/phonepe/phonepe.module": [
		"./src/app/pages/payment-ui/phonepe/phonepe.module.ts"
	],
	"./pages/payment-ui/stripe/stripe.module": [
		"./src/app/pages/payment-ui/stripe/stripe.module.ts"
	],
	"./pages/place-modal/place-modal.module": [
		"./src/app/pages/place-modal/place-modal.module.ts"
	],
	"./pages/price-slabs/price-slabs.module": [
		"./src/app/pages/price-slabs/price-slabs.module.ts",
		"common",
		"pages-price-slabs-price-slabs-module"
	],
	"./pages/privacy-policy/privacy-policy.module": [
		"./src/app/pages/privacy-policy/privacy-policy.module.ts",
		"pages-privacy-policy-privacy-policy-module"
	],
	"./pages/refund-policy/refund-policy.module": [
		"./src/app/pages/refund-policy/refund-policy.module.ts",
		"pages-refund-policy-refund-policy-module"
	],
	"./pages/region-modal/region-modal.module": [
		"./src/app/pages/region-modal/region-modal.module.ts",
		"common",
		"pages-region-modal-region-modal-module"
	],
	"./pages/resale-order/resale-order.module": [
		"./src/app/pages/resale-order/resale-order.module.ts",
		"default~pages-resale-order-resale-order-module~user-order-details-user-order-details-module",
		"pages-resale-order-resale-order-module"
	],
	"./pages/search-items/search-items.module": [
		"./src/app/pages/search-items/search-items.module.ts",
		"pages-search-items-search-items-module"
	],
	"./pages/search-results/search-results.module": [
		"./src/app/pages/search-results/search-results.module.ts",
		"pages-search-results-search-results-module"
	],
	"./pages/select-addon/repeat-addon-choice/repeat-addon-choice.module": [
		"./src/app/pages/select-addon/repeat-addon-choice/repeat-addon-choice.module.ts"
	],
	"./pages/select-addon/select-addon.module": [
		"./src/app/pages/select-addon/select-addon.module.ts"
	],
	"./pages/select-language/select-language.module": [
		"./src/app/pages/select-language/select-language.module.ts"
	],
	"./pages/shipping-policy/shipping-policy.module": [
		"./src/app/pages/shipping-policy/shipping-policy.module.ts",
		"pages-shipping-policy-shipping-policy-module"
	],
	"./pages/shop-by-brand/shop-by-brand.module": [
		"./src/app/pages/shop-by-brand/shop-by-brand.module.ts",
		"pages-shop-by-brand-shop-by-brand-module"
	],
	"./pages/shop-by-category/shop-by-category.module": [
		"./src/app/pages/shop-by-category/shop-by-category.module.ts",
		"pages-shop-by-category-shop-by-category-module"
	],
	"./pages/size-chart-modal/size-chart-modal.module": [
		"./src/app/pages/size-chart-modal/size-chart-modal.module.ts"
	],
	"./pages/splash-screen/splash-screen.module": [
		"./src/app/pages/splash-screen/splash-screen.module.ts"
	],
	"./pages/tagged-items/tagged-items.module": [
		"./src/app/pages/tagged-items/tagged-items.module.ts",
		"pages-tagged-items-tagged-items-module"
	],
	"./pages/term-condition/term-condition.module": [
		"./src/app/pages/term-condition/term-condition.module.ts",
		"pages-term-condition-term-condition-module"
	],
	"./pages/test-page/test-page.module": [
		"./src/app/pages/test-page/test-page.module.ts"
	],
	"./pages/upi-manual-payment/upi-manual-payment.module": [
		"./src/app/pages/upi-manual-payment/upi-manual-payment.module.ts"
	],
	"./pages/user-referral/user-referral.module": [
		"./src/app/pages/user-referral/user-referral.module.ts",
		"pages-user-referral-user-referral-module"
	],
	"./pages/vendor-info/vendor-info.module": [
		"./src/app/pages/vendor-info/vendor-info.module.ts",
		"pages-vendor-info-vendor-info-module"
	],
	"./pages/vendor-invoices/vendor-invoices.module": [
		"./src/app/pages/vendor-invoices/vendor-invoices.module.ts"
	],
	"./pages/vendor-registration/vendor-registration.module": [
		"./src/app/pages/vendor-registration/vendor-registration.module.ts",
		"pages-vendor-registration-vendor-registration-module"
	],
	"./pages/video-modal/video-modal.module": [
		"./src/app/pages/video-modal/video-modal.module.ts"
	],
	"./payment-link/payment-link.module": [
		"./src/app/payment-link/payment-link.module.ts",
		"payment-link-payment-link-module"
	],
	"./paytm/payment-response/payment-response.module": [
		"./src/app/paytm/payment-response/payment-response.module.ts",
		"paytm-payment-response-payment-response-module"
	],
	"./paytm/paytm-callback/paytm-callback.module": [
		"./src/app/paytm/paytm-callback/paytm-callback.module.ts",
		"paytm-paytm-callback-paytm-callback-module"
	],
	"./paytm/paytm-initiate-txn/paytm-initiate-txn.module": [
		"./src/app/paytm/paytm-initiate-txn/paytm-initiate-txn.module.ts",
		"paytm-paytm-initiate-txn-paytm-initiate-txn-module"
	],
	"./pick-and-drop/pick-and-drop.module": [
		"./src/app/pick-and-drop/pick-and-drop.module.ts",
		"pick-and-drop-pick-and-drop-module"
	],
	"./pick-and-drop/pick-drop-details/pick-drop-details.module": [
		"./src/app/pick-and-drop/pick-drop-details/pick-drop-details.module.ts"
	],
	"./pick-and-drop/pick-drop-map/pick-drop-map.module": [
		"./src/app/pick-and-drop/pick-drop-map/pick-drop-map.module.ts"
	],
	"./pricelist-modal/pricelist-modal.module": [
		"./src/app/pricelist-modal/pricelist-modal.module.ts"
	],
	"./product-details/product-details.module": [
		"./src/app/product-details/product-details.module.ts",
		"default~buynow-pricelist-modal-buynow-pricelist-modal-module~product-details-product-details-module",
		"common",
		"product-details-product-details-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./promo-modal/promo-modal.module": [
		"./src/app/promo-modal/promo-modal.module.ts"
	],
	"./promo-popup-modal/promo-popup-modal.module": [
		"./src/app/promo-popup-modal/promo-popup-modal.module.ts",
		"promo-popup-modal-promo-popup-modal-module"
	],
	"./rating/all-ratings/all-ratings.module": [
		"./src/app/rating/all-ratings/all-ratings.module.ts",
		"common",
		"rating-all-ratings-all-ratings-module"
	],
	"./rating/rate-order/rate-order.module": [
		"./src/app/rating/rate-order/rate-order.module.ts"
	],
	"./rating/rate-product/rate-product.module": [
		"./src/app/rating/rate-product/rate-product.module.ts"
	],
	"./select-address/select-address.module": [
		"./src/app/select-address/select-address.module.ts"
	],
	"./shop-filters/shop-filters.module": [
		"./src/app/shop-filters/shop-filters.module.ts"
	],
	"./shop/shop-subcategories/shop-subcategories.module": [
		"./src/app/shop/shop-subcategories/shop-subcategories.module.ts",
		"common",
		"shop-shop-subcategories-shop-subcategories-module"
	],
	"./shop/shop.module": [
		"./src/app/shop/shop.module.ts",
		"common",
		"shop-shop-module"
	],
	"./sidemenu/sidemenu.module": [
		"./src/app/sidemenu/sidemenu.module.ts",
		"sidemenu-sidemenu-module"
	],
	"./terms-conditions/terms-conditions.module": [
		"./src/app/terms-conditions/terms-conditions.module.ts",
		"terms-conditions-terms-conditions-module"
	],
	"./terms-privacy/terms-privacy.module": [
		"./src/app/terms-privacy/terms-privacy.module.ts",
		"terms-privacy-terms-privacy-module"
	],
	"./user-addresses/user-addresses.module": [
		"./src/app/user-addresses/user-addresses.module.ts",
		"user-addresses-user-addresses-module"
	],
	"./user-cart/user-cart.module": [
		"./src/app/user-cart/user-cart.module.ts",
		"user-cart-user-cart-module"
	],
	"./user-feedback/user-feedback.module": [
		"./src/app/user-feedback/user-feedback.module.ts",
		"user-feedback-user-feedback-module"
	],
	"./user-order-details/user-order-details.module": [
		"./src/app/user-order-details/user-order-details.module.ts",
		"default~pages-resale-order-resale-order-module~user-order-details-user-order-details-module",
		"user-order-details-user-order-details-module"
	],
	"./user-order-history/user-order-history.module": [
		"./src/app/user-order-history/user-order-history.module.ts",
		"user-order-history-user-order-history-module"
	],
	"./user-product-subscription/create-subscription/create-subscription.module": [
		"./src/app/user-product-subscription/create-subscription/create-subscription.module.ts"
	],
	"./user-product-subscription/subscription-summary/subscription-summary.module": [
		"./src/app/user-product-subscription/subscription-summary/subscription-summary.module.ts",
		"user-product-subscription-subscription-summary-subscription-summary-module"
	],
	"./user-product-subscription/user-subscriptions/user-subscriptions.module": [
		"./src/app/user-product-subscription/user-subscriptions/user-subscriptions.module.ts",
		"user-product-subscription-user-subscriptions-user-subscriptions-module"
	],
	"./user-services/request-details/request-details.module": [
		"./src/app/user-services/request-details/request-details.module.ts",
		"user-services-request-details-request-details-module"
	],
	"./user-services/service-response/service-response.module": [
		"./src/app/user-services/service-response/service-response.module.ts",
		"common",
		"user-services-service-response-service-response-module"
	],
	"./user-services/user-services/user-services.module": [
		"./src/app/user-services/user-services/user-services.module.ts",
		"common",
		"user-services-user-services-user-services-module"
	],
	"./user-wallet/user-wallet.module": [
		"./src/app/user-wallet/user-wallet.module.ts",
		"common",
		"user-wallet-user-wallet-module"
	],
	"./user-wishlist/user-wishlist.module": [
		"./src/app/user-wishlist/user-wishlist.module.ts",
		"user-wishlist-user-wishlist-module"
	],
	"./wallet-transactions-modal/wallet-transactions-modal.module": [
		"./src/app/wallet-transactions-modal/wallet-transactions-modal.module.ts",
		"common",
		"wallet-transactions-modal-wallet-transactions-modal-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;